import * as React from 'react';
import { cn } from '@ais-ui/utils';
import { TableDockProvider, type TableDockContextValue } from './context';

export interface TableDockProps extends React.ComponentProps<'div'> {
  /** Number of selected rows (defaults to 0). */
  selectedCount?: number;
  /** True when rendered inside its own pop-out window (defaults to false). */
  isDetached?: boolean;
}

/**
 * The rail itself: a fixed 44px band that lays the three zones out left→right
 * and shares selection/detached state with its parts via context.
 */
export const TableDockRoot = ({
  selectedCount = 0,
  isDetached = false,
  className,
  children,
  ...props
}: TableDockProps) => {
  const contextValue = React.useMemo<TableDockContextValue>(
    () => ({ selectedCount, isDetached }),
    [selectedCount, isDetached],
  );

  return (
    <TableDockProvider value={contextValue}>
      <div
        data-slot="table-dock"
        className={cn(
          'flex h-11 shrink-0 items-center gap-2 pl-3 pr-2',
          className,
        )}
        {...props}
      >
        {children}
      </div>
    </TableDockProvider>
  );
};
